<template>
  <div>
    <ChatBubble v-if="!showChat" />
    <div class="resizeable-area">
      <DxResizable
        id="chatContainer"
        :keep-aspect-ratio="false"
        :min-width="300"
        :min-height="320"
        :max-height="1600"
        :max-width="2400"
        handles="left top topleft"
        :class="showChat ? 'borderVisible' : ''"
        v-if="showChat"
      >
        <div class="chat-container" v-show="showChat">
          <div class="row chat-options justify-between">
            <span class="chat-title">Chat title</span>
            <div class="chat-icon-options-row row justify-center">
              <i
                class="dx-icon-copy chat-icon-option"
                style="margin-right: 4px"
                @click="copyChat"
                id="copyChatIcon"
                :aria-label="t('chat.copy')"
              ></i>
              <DxTooltip
                :hide-on-outside-click="false"
                target="#copyChatIcon"
                show-event="mouseenter"
                hide-event="mouseleave"
                position="top"
                :container="'body'"
              >
                {{ t("chat.copy") }}
              </DxTooltip>
              <i
                class="dx-icon-refresh chat-icon-option"
                style="margin-right: 4px"
                @click="refreshChat"
                id="refreshChatIcon"
                :aria-label="t('chat.refresh')"
              ></i>
              <DxTooltip
                :hide-on-outside-click="false"
                target="#refreshChatIcon"
                show-event="mouseenter"
                hide-event="mouseleave"
                position="top"
                :container="'body'"
              >
                {{ t("chat.refresh") }}
              </DxTooltip>
              <i
                class="dx-icon-close chat-icon-option"
                @click="closeChat"
                id="closeChatIcon"
                :aria-label="t('chat.close')"
              ></i>
              <DxTooltip
                :hide-on-outside-click="false"
                target="#closeChatIcon"
                show-event="mouseenter"
                hide-event="mouseleave"
                position="top"
                :container="'body'"
              >
                {{ t("chat.close") }}
              </DxTooltip>
            </div>
          </div>

          <div class="chat-box">
            <DxChat
              :items="messages"
              :user="currentUser"
              :showAvatar="true"
              :showUserName="true"
              :showDayHeaders="true"
              :showMessageTimestamp="true"
              :dayHeaderFormat="'dd/MM/yyyy'"
              :messageTimestampFormat="'hh:mm a'"
              @message-entered="onMessageEntered"
              class="chat-content"
            />
          </div>
        </div>
      </DxResizable>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeMount /* , onMounted  */ } from "vue";
import store from "../../store/index";
import { useI18n } from "vue-i18n";

import ChatBubble from "./ChatBubble.vue";

import { DxChat } from "devextreme-vue/chat";
import { DxTooltip } from "devextreme-vue/tooltip";
import DxResizable from "devextreme-vue/resizable";

import { Guid } from "devextreme-vue/common";
import aiService from "../../services/ai.service";
const { t } = useI18n();

const showChat = computed({
  get: () => store.state.chat.showChat,
});

const copyChat = () => {
  console.log("Chat copy");
};
const refreshChat = () => {
  console.log("Chat refresh");
};
const closeChat = () => {
  store.commit("chat/updateShowChat", false);
};

onBeforeMount(async () => {
  if (store.state.chat.settings === null) await aiService.getAISettings();
  else if (JSON.parse(sessionStorage.getItem("chatMessages")) == null)
    sessionStorage.setItem(
      "chatMessages",
      JSON.stringify(store.state.chat.currentChatMessages)
    );
  if (
    (JSON.parse(sessionStorage.getItem("chatMessages")) == null ||
      JSON.parse(sessionStorage.getItem("chatMessages")).length == 0) &&
    store.state.chat.currentChatMessages.length == 0
  ) {
    store.commit(store.commit("chat/resetCurrentMessages"));
  }
});
const currentUser = computed({
  get: () => store.state.chat.currentUser,
});

const messages = computed({
  get: () =>
    store.state.chat.currentChatMessages != null &&
    store.state.chat.currentChatMessages.length > 1
      ? store.state.chat.currentChatMessages
      : JSON.parse(sessionStorage.getItem("chatMessages")),
});

const supportAgent = computed({
  get: () => store.state.chat.supportAgent,
});

const onMessageEntered = (e) => {
  const newMessage = {
    id: new Guid().toString(),
    ...e.message,
  };
  const getTimestamp = (date, offsetMinutes = 0) => {
    return date.getTime() + offsetMinutes * 60000;
  };
  const date = new Date();
  const autoReply = {
    id: new Guid().toString(),
    timestamp: getTimestamp(date, -9),
    author: supportAgent.value,
    text: "Auto reply simulation for testing.",
  };

  if (messages.value.length > store.state.chat.currentChatMessages.length) {
    store.state.chat.currentChatMessages = [...messages.value, newMessage];
    store.state.chat.currentChatMessages = [...messages.value, autoReply];
  } else {
    store.state.chat.currentChatMessages = [
      ...store.state.chat.currentChatMessages,
      newMessage,
    ];
    store.state.chat.currentChatMessages = [
      ...store.state.chat.currentChatMessages,
      autoReply,
    ];
  }

  sessionStorage.setItem(
    "chatMessages",
    JSON.stringify(store.state.chat.currentChatMessages)
  );
};
</script>

<style scoped lang="scss">
.options {
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-width: 280px;
  background-color: rgba(191, 191, 191, 0.15);
  gap: 16px;
}

.caption {
  font-size: 14px;
  font-weight: 500;
}

.option-separator {
  border-bottom: 1px solid #0a108f;
}

.dx-avatar {
  border: 1px solid #0a108f;
}

#chatContainer {
  width: 420px;
  height: 540px;
  bottom: 20px;
  right: 20px;
  position: fixed;
  z-index: 999;
  max-height: 90vh;
  max-width: 93vw;
  /*
  Note: Keep this, translate(0,0) will keep chat in fixed position
  if a better solution is found I'll implement it.
  */
  transform: translate(0, 0) !important;
}

.borderVisible {
  border-radius: 10px;
  background: white;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}
</style>
